<template>
  <app-content class="h-panel">
    <Loading text="数据加载中..." :loading="loading"></Loading>
    <div class="h-panel-bar">
      <span class="h-panel-title">资产负债表月报</span>
    <div class="float-right">
      <Button size="s" icon="fa fa-print" @click="printReport">打印</Button>
      <DropdownMenu button @click="ioTrigger" :datas="ioMenus" size="s">导出</DropdownMenu>
    </div>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <account-date-choose v-model="accountDate"/>
      </Cell>
      <Cell class="label">核算组织：</Cell>
      <Cell>
        <TreePicker :option="orgOption"  style="display: inline-block;min-width: 150px"
                    ref="orgTreePicker" v-model="orgId"></TreePicker>
      </Cell>
      <Cell>
        <Button :disabled="!report" :loading="loading" color="primary" @click="doSearch">查询</Button>
      </Cell>
    </Row>
    <div class="h-panel-body" v-if="report">
      <Table :datas="templateItemsRender" selectRow border>
        <TableItem title="资产">
          <div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
        </TableItem>
        <TableItem title="行次">
          <template slot-scope="{data}">
            {{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
          </template>
        </TableItem>
        <TableItem title="期末余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem title="年初余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem :title="liabilitiesTitle">
          <div slot-scope="{data}" :class="{'font-bold':data.fs_isBolder}" :style="{paddingLeft:((data.fs_level-1)*15)+'px'}">{{data.fs_title}}</div>
        </TableItem>
        <TableItem title="行次">
          <template slot-scope="{data}">
            {{data.fs_isClassified ? '':data.fs_lineNum>-1?data.fs_lineNum:''}}
          </template>
        </TableItem>
        <TableItem title="期末余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.fs_id]?reportData[data.fs_id].currentPeriodAmount:''|numFormat}}
          </template>
        </TableItem>
        <TableItem title="年初余额" align="right">
          <template slot-scope="{data}">
            {{reportData[data.fs_id]?reportData[data.fs_id].currentYearAmount:''|numFormat}}
          </template>
        </TableItem>
      </Table>
    </div>
    <Modal v-model="batchModal" title="批量导出" :width="520">
    <div class="padding">
      <p class="dark2-color">每期导出为一个工作表，单次最多导出 36 期。</p>
      <Row type="flex" :space-x="10" class="margin-top" :align="'middle'">
        <Cell class="label">开始期间</Cell>
        <Cell><account-date-choose v-model="batchStart"/></Cell>
        <Cell class="label">结束期间</Cell>
        <Cell><account-date-choose v-model="batchEnd"/></Cell>
      </Row>
    </div>
    <div slot="footer">
      <Button @click="batchModal=false">取消导出</Button>
      <Button color="primary" :loading="batchLoading" @click="doExportBatch">开始导出</Button>
    </div>
  </Modal>
</app-content>
</template>

<script>
  import reportIoMixin from '../../js/common/report-io-mixin';
import {mapState} from 'vuex'

export default {
  name: "BalanceStatement",
  mixins: [reportIoMixin],
  data() {
    return {
      orgOption: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'title',
        dataMode: 'list',
        datas: []
      },
      report: null,
      reportData: {},
      accountDate: null,
      dataList: [],
      orgId: null,
      org: null,
      loading: false
    }
  },
  computed: {
    ...mapState(['User','orgDatas', 'currentOrgId', 'currentAccountSets']),
    liabilitiesTitle() {
      // 民非(np)/工会准则账套右栏为「负债和净资产」，其余准则为「负债和所有者权益」
      const tpl = this.currentAccountSets && this.currentAccountSets.accountTemplate;
      return /^(NP|UNION)/.test(tpl || '') ? '负债和净资产' : '负债和所有者权益';
    },
    templateItems() {
      return this.report ? this.report.items : [];
    },
    templateItemsRender() {
      if (this.report && this.templateItems) {
        //所有资产
        let zc = this.templateItems.filter(val => val.type === 0);
        let sq = this.templateItems.filter(val => val.type !== 0);
        sq.forEach((val, index) => {
          let changeObj = {
            fs_id: val.id,
            fs_lineNum: val.lineNum,
            fs_isBolder: val.isBolder,
            fs_level: val.level,
            fs_isClassified: val.isClassified,
            fs_title: val.title
          };
          if (zc[index]) {
            Object.assign(zc[index], changeObj);
          }
        });
        return zc;
      }
      return [];
    }
  },
  methods: {
    doSearch() {
      this.loadReport();
    },
    loadReport() {
      Api.report.template.list().then(({data}) => {
        const tpl = data.find(t => t.templateKey === 'zcfzb');
        if (!tpl) {
          this.loading = false;
          this.$Message.success('未授权资产负债表模板~');
          return;
        }
        Api.report.template.load(tpl.id).then(({data: rpt}) => {
          this.report = rpt;
          this.$nextTick(this.loadReportData);
        });
      });
    },
    loadReportData() {
      if (this.accountDate) {
        this.loading = true;
        Api.report.view(this.report.id, {accountDate: this.accountDate, orgId: this.orgId, dimension: 'MONTH'}).then(({data}) => {
          this.reportData = data;
        }).finally(() => this.loading = false);
      } else {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.currentOrgId) {
      this.orgId = this.currentOrgId;
    }
    if (this.orgDatas && this.orgDatas.length) {
      this.orgOption.datas = this.orgDatas.map(val => {
        return {id: val.id, name:val.name, type: val.type, title: `[${val.code}]${val.name}`, parentId: val.parentId,currentAccountDate:val.currentAccountDate,enableDate:val.enableDate}
      });
    } else {
      this.$watch('orgDatas', () => {
        if (this.orgDatas && this.orgDatas.length && !this.orgOption.datas.length) {
          this.orgOption.datas = this.orgDatas.map(val => ({id: val.id, name:val.name, type: val.type, title: `[${val.code}]${val.name}`, parentId: val.parentId,currentAccountDate:val.currentAccountDate,enableDate:val.enableDate}));
        }
      }, { immediate: true });
    }
    this.$nextTick(() => {
      this.$refs.orgTreePicker.expandAll();
    });
    this.loadReport();
  }
}
</script>

<style scoped>
div.font-bold {
  font-size: 14px;
}
</style>